import { PureLightTheme } from "../../../../styles/theme"

export const AvatarStyle = {
    width: "45px", 
    height: "45px", 
    marginRight: '16px',
    [PureLightTheme.breakpoints.down('sm')]: {
        width: "35px", 
        height: "35px", 
        marginRight: '12px',
    }
}

export const StackWithComment = {
    width: '100%', 
    minHeight: '65px', 
}

export const TypNameLastName = {
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    overflowWrap: 'anywhere',
}

export const TypDate = {
    marginRight: '17px',
}

export const TypAnswer = {
    cursor: 'pointer', 
    "&:hover": {
        textDecoration: 'underline',
    }
}

export const ButtonStyle = {
    minWidth: "auto",
    padding: '0px',
    
    "&:hover": {
        backgroundColor: "transparent",
    },
}
